import type { FunctionComponent } from 'react';
import { Inline } from '@atlaskit/primitives/compiled';

import Logo from './Logo';
import Arrows from './Arrows';
import AtlassianUserIcon from './AtlassianUserIcon';

const AppLogos: FunctionComponent = () => (
  <Inline alignBlock="center" space={'space.250'}>
    <Logo />
    <Arrows />
    <AtlassianUserIcon />
  </Inline>
);

export default AppLogos;
